import { render, staticRenderFns } from "./AutomazioneGlobal.vue?vue&type=template&id=154affc5&"
import script from "./AutomazioneGlobal.vue?vue&type=script&lang=js&"
export * from "./AutomazioneGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports